import { LoaderCircle, LogOut } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { deconnexion } from '../connexion/requetes';

/** Ferme la session côté serveur puis renvoie vers l'écran de connexion. */
export function BoutonDeconnexion({
  apres = () => window.location.assign('/connexion'),
}: {
  /** Action après la déconnexion (redirection par défaut, remplaçable dans les tests). */
  apres?: () => void;
}) {
  const [envoi, setEnvoi] = useState(false);

  async function deconnecter() {
    setEnvoi(true);
    try {
      await deconnexion();
      apres();
    } catch {
      setEnvoi(false);
      toast.error('La déconnexion a échoué. Réessayez dans un instant.');
    }
  }

  return (
    <button
      type="button"
      onClick={() => void deconnecter()}
      disabled={envoi}
      className="cible inline-flex items-center justify-center gap-2 rounded-lg px-3 text-sm text-doux hover:text-texte disabled:opacity-60"
    >
      {envoi ? (
        <LoaderCircle size={18} className="animate-spin" aria-hidden />
      ) : (
        <LogOut size={18} aria-hidden />
      )}
      <span className="sr-only sm:not-sr-only">Se déconnecter</span>
    </button>
  );
}
